import * as React from 'react';
import { SaleCenterStatusDTO, TicketLocationDTO, SaleLocationStatusDTO } from 'core/api';
import { SaleLocationStatus } from './SaleLocationStatus';
import { Guid } from 'core/infrastructure';
import { Box, Grid, HStack, Separator, VStack } from '@chakra-ui/react';
import { SaleLocationButton } from './SaleLocationButton';
import LocationSelector from './LocationSelector';
import { LargeDeviceOnly } from './LargeDeviceOnly';
import { PhoneOnly } from './PhoneOnly';

type Props = {
	onSaleLocationSelected: (sl: TicketLocationDTO) => void;
	selected: SaleCenterStatusDTO;
};

export function create(status: SaleLocationStatus) {

	return function SaleCentersContent(props: Props) {

		const onSaleCenterSelected = (saleCenterId: number) => status.selectSaleCenter(saleCenterId);
		const onSaleLocationSelected = (sl: SaleLocationStatusDTO) => props.onSaleLocationSelected(sl.TicketLocation);

		const locations = props.selected.SaleLocations.map(l => ({
			...l,
			Style: {
				Text: l.TicketLocation.SaleLocationName,
				ImageId: Guid.empty,
				BackColor: props.selected.Style.BackColor
			}
		}));

		const saleCenters = status.getAllSaleCenters().map(s => ({
			id: s.Id,
			selected: s.Id === props.selected.Id,
			Style: s.Style
		}));

		return <>
			<PhoneOnly>
				<VStack width={'full'} paddingY={'4'} paddingX={'2'} gap={'3'}>
					<LocationSelector items={saleCenters} onItemSelected={onSaleCenterSelected} />
					<Separator width={'full'} height={'1px'} borderColor={'transparent'} bg={{ base: '{colors.neutral.300}', _dark: '{colors.neutral.300}' }} />
					<Grid
						width={'full'}
						templateColumns={{ base: 'repeat(auto-fill, 7.375rem)', mdDown: 'repeat(auto-fill, 4rem)' }}
						gridAutoRows={'4rem'}
						gap={{ mdDown: 2, md: 6 }}
						justifyContent={'space-evenly'}
					>
						{
							locations.map((location, index) => {
								return <SaleLocationButton key={index} location={location} onValueSelected={onSaleLocationSelected} />;
							})
						}
					</Grid>
				</VStack>
			</PhoneOnly>
			<LargeDeviceOnly>
				<HStack gap={'6'} width={'full'} height={'full'} paddingY={'6'} paddingX={'5'}>
					<Box width={'auto'} height={'full'}>
						<LocationSelector items={saleCenters} onItemSelected={onSaleCenterSelected} orientation={'vertical'} />
					</Box>
					<Separator width={'1.25px'} height={'full'} borderColor={'transparent'} bg={{ base: '{colors.neutral.300}', _dark: '{colors.neutral.300}' }} />
					<Box width={'full'} height={'full'}>
						<Grid
							templateColumns={{ base: 'repeat(auto-fill, 6rem)', mdDown: 'repeat(auto-fill, 4rem)' }}
							gridAutoRows={'4.5rem'}
							gap={{ mdDown: 3, md: 5 }}
							justifyContent={'space-between'}
						>
							{
								locations.map((location, index) => {
									return <SaleLocationButton key={index} location={location} onValueSelected={onSaleLocationSelected} />;
								})
							}
						</Grid>
					</Box>
				</HStack>
			</LargeDeviceOnly>
		</>;
	};
}

